module.exports = __webpack_public_path__ + "flyer_background_architecture_071-e77042b8d388f4035c83fecc5bfda699.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_architecture_071.jpg
// module id = 1597
// module chunks = 1